/** @jsx jsx */

import { jsx , css } from '@emotion/react';
import {  Link  } from 'gatsby';
import * as breakpoint from '../../styles/breakpoints.module.scss';
import { StaticImage } from "gatsby-plugin-image"

const PageHeadlineBlock =  ({ alt }) => {
	return (
    <section css={css`
      position:relative;
      min-height: 296px;
      overflow:hidden;


      @media only screen and (max-width: ${breakpoint.smMax})
      {
        min-height: 152px;
      }
    `}>
      <StaticImage src={'../../images/layout/header_list.jpg'} 
        css={css`
          width:100%;
          height:290px;
          position:absolute;
          left: 0;
          @media only screen and (max-width: ${breakpoint.smMax})
          {
            height: 152px;
          }
        `} alt={alt}/>
        <div css={css`
          position:absolute;
          width: 242px;
          height: 91px;
          top:calc(64px - 9px);
          left:calc(32px - 9px);
          z-index: 2;
          transition-delay: 2.5s;
          transition:opacity .7s;

          @media only screen and (max-width: ${breakpoint.smMax})
          {
            width: 200px;
            height: 64px;
            transform: translate(0,-50%);
            top: 91px;
            left:auto;
            right:50%;
            margin-right:16px;
          }

          @media only screen and (max-width: ${breakpoint.xsMax}) and (max-aspect-ratio: 1/1)
          {
            
            width: 128px;
            height: 40px;
            margin-right:8px;
          }
        `}>
          <a href="https://www.finalfantasyxiv.com/" target="_blank" rel="noreferrer" >
            <StaticImage src={'../../images/layout/logo_ffxiv.png'} alt={'ファイナルファンタジーXIV'} placeholder={'none'}/>
          </a>
        </div>
        <div css={css`position:absolute;
          left:50%;
          top:50%;
          margin-top:19px;
          transform:translate(-50%,-50%);
          z-index:2;
          width:241px;
          height:268px;
          @media only screen and (max-width: ${breakpoint.smMax})
          {
            height:120px;
            width:106px;
            top:auto;
            transform:none;
            bottom:0;
            left:50%;
            margin-left:96px;
          }
          @media only screen and (max-width: ${breakpoint.xsMax})
          {
            margin-left:32px;
          }

        `}>
        <Link to='/'>
          <StaticImage src={'../../images/layout/subLogo.png'} alt={alt} placeholder={'none'}/>
        </Link>
        </div>
    </section>
	);
}

export default PageHeadlineBlock;
